<template>
    <div class="d-flex justify-content-between gap-5">
        <div class="p-0 bd-highlight">
            <paginate v-model="in_pageIndex" :page-count="PageCount" :click-handler="paginateCallback" :page-range="3"
                :margin-pages="2" :prev-text="'قبلی'" :next-text="'بعدی'" :first-last-button="true"
                :first-button-text="'اول'" :last-button-text="'آخر'"
                :container-class="'pagination pagination-primary pagination-lg'" :page-class="'page-item'">
            </paginate>
        </div>
        <div class="align-self-center flex-shrink-0">
            {{ "تعداد کل: " + totalRecordCount }}
        </div>
        <div class="p-0 bd-highlight align-self-center flex-shink-0">
            <select class="form-control" :value="pageSize" @change="$emit('update:pageSize', $event.target.value)">
                <option v-for="item in listPageSize" v-bind:key="item">
                    {{ item }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import Paginate from "vuejs-paginate-next"
export default {
    name: "pagination",
    // emits: "change-callback",
    props: {
        totalRecordCount: { type: Number, require: true },
        listPageSize: { type: Array, default: [10, 15, 20, 30, 50] },
        pageSize: { type: Number, default: 15 },
        pageIndex: { type: Number, default: 0 },
    },
    data() {
        return {
            in_pageIndex: 1,
            PageCount: 1
        }
    },
    methods: {
        paginateCallback(pageNum) {
            this.$emit('change-callback', pageNum, parseInt(this.pageSize));
        }
    },
    watch: {
        pageSize() {
            this.PageCount = Math.ceil(this.totalRecordCount / this.pageSize);
            this.in_pageIndex = 1;
            this.paginateCallback(this.in_pageIndex);
        },
        totalRecordCount() {
            this.PageCount = Math.ceil(this.totalRecordCount / this.pageSize);
            this.in_pageIndex = this.pageIndex + 1;
        },
    },
    components: {
        Paginate
    },
    created() {
        if (this.pageIndex != null && this.pageIndex >= 0)
            this.in_pageIndex = this.pageIndex + 1;

        this.PageCount = Math.ceil(this.totalRecordCount / this.pageSize);

    },
    emits: ['update:pageSize']
};
</script>
